import { FullSizeCanvas } from './fullSizeCanvas';

export class FullScreenSequence {
    constructor(options = null) {
        const _ = this;

        _.option = $.extend(
            {
                $wrap: null,
                spriteObj: {
                    img: null,
                    width: 100,
                    height: 100,
                    frameNum: 1,
                    fps: 1,
                    isLoop: false
                },
                emitter: null
            },
            options
        );

        // _.model = SingletonModel.getInstance();

        _.emitter = _.option.emitter;

        _.$wrap = _.option.$wrap;

        _.fullscreenCanvas = null;
    }

    init(obj = null) {
        const _ = this;

        _.fullscreenCanvas = new FullSizeCanvas({
            $parent: _.$wrap,
            canvasClass: 'canvas',
            width: 1920,
            height: 1080,
            alignX: 'center',
            alignY: 'top',
            spriteObj: _.option.spriteObj,
            onFinish: () => {
                _.fullscreenCanvas.show(false);

                // emit depth1 index
                _.emitter.emit('COMPLETE_SEQUENCE_ANIMATION', null);

                // _.model.isEnableMouseWheel = true;
            }
        }).init();

        _.fullscreenCanvas.show(false);

        return _;
    }

    restart(obj = null) {
        const _ = this;

        _.fullscreenCanvas.restart();

        _.fullscreenCanvas.show(true);

        return _;
    }

    destroy(obj = null) {
        const _ = this;

        return _;
    }
}
